import gql from 'graphql-tag';

export const CreateParticipantTaskTemplate = gql`
  mutation CreateParticipantTaskTemplate(
    $organizationId: ID!
    $request: CreateParticipantTaskTemplateRequest!
  ) {
    createParticipantTaskTemplate(
      organizationId: $organizationId
      request: $request
    ) {
      id
      name
      requiresDueDate
      recurrence {
        intervalDays
        completedAt
      }
      labels {
        id
        name
        color
        description
      }
      createdAt
      updatedAt
    }
  }
`;
